import { Department, Team } from '@/types/database';

interface RespondentFiltersProps {
  departments: Department[];
  teams: Team[];
  selectedDepartment: string | null;
  selectedTeam: string | null;
  onDepartmentChange: (departmentId: string | null) => void;
  onTeamChange: (teamId: string | null) => void;
}

export function RespondentFilters({
  departments,
  teams,
  selectedDepartment,
  selectedTeam,
  onDepartmentChange,
  onTeamChange
}: RespondentFiltersProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4">
      <div className="flex items-center space-x-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Department
          </label>
          <select
            value={selectedDepartment || ''}
            onChange={(e) => onDepartmentChange(e.target.value || null)}
            className="block w-full rounded-md border-gray-300 dark:border-gray-600 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          >
            <option value="">All Departments</option>
            {departments.map((dept) => (
              <option key={dept.id} value={dept.id}>{dept.name}</option>
            ))}
          </select>
        </div>
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Team
          </label>
          <select
            value={selectedTeam || ''}
            onChange={(e) => onTeamChange(e.target.value || null)}
            disabled={!selectedDepartment}
            className="block w-full rounded-md border-gray-300 dark:border-gray-600 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white disabled:opacity-50"
          >
            <option value="">All Teams</option>
            {teams
              .filter((team) => team.department_id === selectedDepartment)
              .map((team) => (
                <option key={team.id} value={team.id}>{team.name}</option>
              ))}
          </select>
        </div>
      </div>
    </div>
  );
}